// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .media-heading{
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.media-container{
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
    border-top: none;
}

.audio-video-button{
    height: 50px;
    width: 180px;
    border: 1px solid #e4e4e4;
    background-color: #ffffff;
    outline: none;
    font-size: 18px;
}

.audio{
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
.video{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.media-active-button{
    border: none;
    background-color:  #c64944;
    color: #ffffff;
}

.add-media-button{
    height: 50px;
    width: 200px;
    border: none;
    background-color: #5eb877;
    color: #ffffff;
    border-radius: 10px;
    outline: none;
    margin-right: 15px;
    font-size: 18px;
}

.inputfile{
    width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.inputfile + label {
    font-size: 18px;
    color: white;
    font-family: "Roboto";
    background-color:  #5eb877;
    display: inline-block;
    padding: 0.5rem 1rem;
    border: 1px solid #5eb877;
    border-radius: 10px;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s,
      box-shadow 0.2s;
}
.inputfile + label {
  cursor: pointer;
} */



.media-heading {
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.media-container {
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
    border-top: none;
}

.audio-video-button {
    height: 50px;
    width: 180px;
    border: 1px solid #e4e4e4;
    background-color: #ffffff;
    outline: none;
    font-size: 18px;
}

.audio {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.video {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.media-active-button {
    border: none;
    background-color: #c64944;
    color: #ffffff;
}

.add-media-button {
    height: 50px;
    width: 200px;
    border: none;
    background-color: #5eb877;
    color: #ffffff;
    border-radius: 10px;
    outline: none;
    margin-right: 15px;
    font-size: 18px;
}

.inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.inputfile+label {
    font-size: 18px;
    color: white;
    font-family: "Roboto";
    background-color: #5eb877;
    display: inline-block;
    padding: 0.5rem 1rem;
    border: 1px solid #5eb877;
    border-radius: 10px;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s,
        box-shadow 0.2s;
}

.inputfile+label {
    cursor: pointer;
}

.media-buttons {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #efeaea;
}

.media-name-heading {
    text-overflow: ellipsis;
    word-break: break-all;
}

.media-Text {
    margin-left: 10;
}

@media (max-width : 426px) {
    .media-buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-bottom: 0px;
    }

    .file-buttons {
        align-items: center;
        display: flex;
        flex-direction: row;
    }

    .audio-video-button {
        height: 50px;
        width: 130px;
        font-size: 18px;
    }

    .media-heading {
        border: 0px solid #e4e4e4;
    }

    hr {
        color: #ffffff;
    }

    .media-container {
        border: 0px solid #e4e4e4;
    }

    .media-card {
        margin-bottom: 16px !important;
        background-color: #F1F3F4;
        border-radius: 16px;
    }

    .media-Text {
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/MediaFiles/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAuEG;;;;AAIH;IACI,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB;uBACmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* .media-heading{\n    background-color: #ffffff;\n    border: 1px solid #e4e4e4;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.media-container{\n    background-color: #ffffff;\n    border: 1px solid #e4e4e4;\n    border-top: none;\n}\n\n.audio-video-button{\n    height: 50px;\n    width: 180px;\n    border: 1px solid #e4e4e4;\n    background-color: #ffffff;\n    outline: none;\n    font-size: 18px;\n}\n\n.audio{\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n.video{\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n.media-active-button{\n    border: none;\n    background-color:  #c64944;\n    color: #ffffff;\n}\n\n.add-media-button{\n    height: 50px;\n    width: 200px;\n    border: none;\n    background-color: #5eb877;\n    color: #ffffff;\n    border-radius: 10px;\n    outline: none;\n    margin-right: 15px;\n    font-size: 18px;\n}\n\n.inputfile{\n    width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.inputfile + label {\n    font-size: 18px;\n    color: white;\n    font-family: \"Roboto\";\n    background-color:  #5eb877;\n    display: inline-block;\n    padding: 0.5rem 1rem;\n    border: 1px solid #5eb877;\n    border-radius: 10px;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s,\n      box-shadow 0.2s;\n}\n.inputfile + label {\n  cursor: pointer;\n} */\n\n\n\n.media-heading {\n    background-color: #ffffff;\n    border: 1px solid #e4e4e4;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.media-container {\n    background-color: #ffffff;\n    border: 1px solid #e4e4e4;\n    border-top: none;\n}\n\n.audio-video-button {\n    height: 50px;\n    width: 180px;\n    border: 1px solid #e4e4e4;\n    background-color: #ffffff;\n    outline: none;\n    font-size: 18px;\n}\n\n.audio {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n.video {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.media-active-button {\n    border: none;\n    background-color: #c64944;\n    color: #ffffff;\n}\n\n.add-media-button {\n    height: 50px;\n    width: 200px;\n    border: none;\n    background-color: #5eb877;\n    color: #ffffff;\n    border-radius: 10px;\n    outline: none;\n    margin-right: 15px;\n    font-size: 18px;\n}\n\n.inputfile {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n\n.inputfile+label {\n    font-size: 18px;\n    color: white;\n    font-family: \"Roboto\";\n    background-color: #5eb877;\n    display: inline-block;\n    padding: 0.5rem 1rem;\n    border: 1px solid #5eb877;\n    border-radius: 10px;\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s,\n        box-shadow 0.2s;\n}\n\n.inputfile+label {\n    cursor: pointer;\n}\n\n.media-buttons {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid #efeaea;\n}\n\n.media-name-heading {\n    text-overflow: ellipsis;\n    word-break: break-all;\n}\n\n.media-Text {\n    margin-left: 10;\n}\n\n@media (max-width : 426px) {\n    .media-buttons {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border-bottom: 0px;\n    }\n\n    .file-buttons {\n        align-items: center;\n        display: flex;\n        flex-direction: row;\n    }\n\n    .audio-video-button {\n        height: 50px;\n        width: 130px;\n        font-size: 18px;\n    }\n\n    .media-heading {\n        border: 0px solid #e4e4e4;\n    }\n\n    hr {\n        color: #ffffff;\n    }\n\n    .media-container {\n        border: 0px solid #e4e4e4;\n    }\n\n    .media-card {\n        margin-bottom: 16px !important;\n        background-color: #F1F3F4;\n        border-radius: 16px;\n    }\n\n    .media-Text {\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
